import actions from '../../actionTypes';

export default filters => {
  return {
    type: actions.SET_FILTERS,
    filters
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/setFilters.js